
export class ClaimsBlocking {
    /**Número de reclamo */
    public CodMotivo:string;
    public CodSubMotivo :string;
    public PeriodoAnno :string;
    public PeriodoMes :string;
    public Interlocutor :string;
    public Contrato :string;
    public CtaContrato :string;
    public UsuarioServicio :string;
    public ClaveServicio :string;
}